import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages';

import { AuthAndACLService } from './../auth_and_acl/authAndACL.service';

import { GrupoService } from './grupo.service';
import { Grupo } from './grupo';

import { PER_PAGE } from './../constante';

@Component({
  selector: 'app-grupos',
  templateUrl: './grupos.component.html',
  providers: [GrupoService]
})

export class GruposComponent  implements OnInit {
  titulo: string = "Grupos";
  public grupos: Grupo[];
  public busy: Promise<any>;
  public paginaAtual: number = 1;
  public itensPorPagina: number = PER_PAGE;

  getGrupos(): void {
    this.busy = this.grupoService.getGrupos()
      .then(grupos => this.grupos = grupos);
  }

  apagar(grupo: Grupo): void {
  //  this.toastyService.default('Hi there');

    if(confirm("Deseja realmente excluir esse grupo? Essa operação não pode ser revertida após a confirmação.")){
      this.busy = this.grupoService.deleteGrupo(grupo)
            .then(() => this.getGrupos());
    }
  }

  constructor( private grupoService: GrupoService, public authAndACL: AuthAndACLService) {

  }

  ngOnInit() {
    this.getGrupos();
  }

}



// WEBPACK FOOTER //
// ./src/app/grupos/grupos.component.ts